document.addEventListener('click', (event)=> {
const checkoutButton = document.querySelector('.checkout-button');
  if(checkoutButton.contains(event.target) && window.hulkapps != undefined) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    hulkappsCheckout();
  }
}, true);